import React from 'react';

const Header = ({ language, onToggleLanguage, currentPage }) => {
    const translations = {
        title: {
            zh: '内容分享平台',
            en: 'Content Sharing Platform'
        },
        home: {
            zh: '首页',
            en: 'Home'
        },
        search: {
            zh: '搜索',
            en: 'Search'
        },
        language: {
            zh: 'English',
            en: '中文'
        }
    };

    return (
        <header>
            <nav className="navbar navbar-expand-lg navbar-dark">
                <div className="container">
                    <a className="navbar-brand" href="/">
                        <i className="bi bi-music-note-beamed me-2"></i>
                        {translations.title[language]}
                    </a>
                    
                    <button 
                        className="navbar-toggler" 
                        type="button" 
                        data-bs-toggle="collapse" 
                        data-bs-target="#navbarNav"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav me-auto">
                            <li className="nav-item">
                                <a 
                                    className={`nav-link ${currentPage === 'home' ? 'active' : ''}`} 
                                    href="/"
                                >
                                    {translations.home[language]}
                                </a>
                            </li>
                        </ul>
                        
                        <div className="d-flex align-items-center">
                            <button 
                                className="btn btn-link text-light language-switcher"
                                onClick={onToggleLanguage}
                            >
                                {translations.language[language]}
                            </button>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Header; 